import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    infoIcon: {
        color: 'grey',
    },
    infoButton: {
        marginLeft: theme.spacing(1),
    },
}));

export default function InfoHover(props) {
    const classes = useStyles();

    return (
        <Tooltip title={props.text} enterDelay={200} placement={'right'}>
            <IconButton disableRipple size="small" className={classes.infoButton}>
                <InfoOutlinedIcon className={classes.infoIcon} />
            </IconButton>
        </Tooltip>
    );
}
